import type { RouteObject } from "react-router";

import Auth from "./views/auth";
import SignIn from "./views/sign-in";
import Error from "@/shared/views/error";

const authRoutes: RouteObject = {
  id: "auth",
  path: "auth",
  element: <Auth />,
  errorElement: <Error />,
  children: [
    {
      id: "sign-in",
      path: "sign-in",
      element: <SignIn />,
    },
  ],
};

export default authRoutes;
